module.exports = __webpack_public_path__ + "9888e44fc5968204b5215ed59c0475ff.svg";